const numeratePolicy = () => {
  const policyPage = document.querySelector('.privacy_page');
  if (!policyPage) return;

  const h2 = [...policyPage.querySelectorAll('h2')];

  h2.length && h2.forEach((h, idx) => {

    const wrapper = document.createElement('div');
    wrapper.classList.add('subtitle-wrapper');
    const num = document.createElement('span');
    num.classList.add('num');
    num.textContent = (idx < 9) ? `0${idx + 1}` : idx + 1;

    h.before(wrapper);
    wrapper.append(h);
    wrapper.append(num);
  });
}


export { numeratePolicy };